import { IDWAppAlert } from "@idw-types/common/idw-app-alert";

export enum AppAlertsActionTypes {
    ADD_APP_ALERT = "ADD_APP_ALERT",
    REMOVE_APP_ALERT = "REMOVE_APP_ALERT",
    CLEAR_APP_ALERTS = "CLEAR_APP_ALERTS",
}

type AddAppAlertAction = {
    type: AppAlertsActionTypes.ADD_APP_ALERT;
    payload: { appAlert: IDWAppAlert };
};

export const addAppAlert = (appAlert: IDWAppAlert): AddAppAlertAction => ({
    type: AppAlertsActionTypes.ADD_APP_ALERT,
    payload: { appAlert }
});

type RemoveAppAlertAction = {
    type: AppAlertsActionTypes.REMOVE_APP_ALERT;
    payload: { appAlertId: string };
};

export const removeAppAlert = (appAlertId: string): RemoveAppAlertAction => ({
    type: AppAlertsActionTypes.REMOVE_APP_ALERT,
    payload: { appAlertId }
});

type ClearAppAlertsAction = {
    type: AppAlertsActionTypes.CLEAR_APP_ALERTS;
};

export const clearAppAlerts = (): ClearAppAlertsAction => ({
    type: AppAlertsActionTypes.CLEAR_APP_ALERTS
});

export type AppAlertsActions =
    AddAppAlertAction |
    RemoveAppAlertAction |
    ClearAppAlertsAction